import React from 'react'
import css from './News.module.css'

const News = (props) => {
    return (
        <div>
            News
        </div>
    )
}

export default News;